import React from "react";
import "./index.css";
// import {
//   DataGrid,
//   GridColDef,
//   GridRowId,
//   GridColumnGroupingModel,
//   useGridApiRef,
//   GridApi,
// } from "@mui/x-data-grid";
import { Collection, CollectionSite, TrapType } from "../../../types";
// import { Button } from "@mui/material";
// import { parseTimeToLocal } from "../../../utils/timeHelper";
import EnhancedTable from "./Table";

interface Props {
  collections: Collection[];
  collectionCount: number;
  paginationModel: { page: number; pageSize: number };
  setPaginationModel: (id: { page: number; pageSize: number }) => void;
  handleSelectCollection: (id: string) => void;
  trapSiteOptions: CollectionSite[];
  trapTypeOptions: TrapType[];
  loading: boolean;
  setSortModel: (order: "desc" | "asc", sortBy: keyof Collection) => void;
}

const CollectionsTable: React.FC<Props> = ({
  collections,
  collectionCount,
  paginationModel,
  setPaginationModel,
  handleSelectCollection,
  trapSiteOptions,
  trapTypeOptions,
  loading,
  setSortModel,
}) => {
  // const gridRef = useGridApiRef<GridApi>();

  // useEffect(() => {
  //   if (gridRef.current) {
  //     gridRef.current.setRowCount(collectionCount);
  //   }
  // }, [collectionCount]);

  // const handleEditClick = (id: GridRowId) => () => {
  //   handleSelectCollection(id as string);
  // };

  // const columnGroupingModel: GridColumnGroupingModel = [
  //   {
  //     groupId: "Collection Details",
  //     children: [
  //       { field: "collectionSiteId" },
  //       { field: "trapTypeId" },
  //       { field: "collectionDate" },
  //     ],
  //   },
  // ];
  // const columns: GridColDef[] = [
  //   {
  //     field: "createdAt",
  //     headerName: "Date",
  //     width: 200,
  //     valueGetter: (value, row) => parseTimeToLocal(value),
  //   },
  //   { field: "displayName", headerName: "Display Name", width: 200 },
  //   {
  //     field: "collectionSiteId",
  //     headerName: "Collection Site",
  //     width: 150,
  //     valueGetter: (value, row) => {
  //       let res: string = "";
  //       trapSiteOptions.forEach((cur) => {
  //         if (cur.id === value) {
  //           res = cur.displayName || "";
  //         }
  //       });
  //       return res;
  //     },
  //   },
  //   {
  //     field: "trapTypeId",
  //     headerName: "Collection Method",
  //     width: 150,
  //     valueGetter: (value, row) => {
  //       let res: string = "";
  //       trapTypeOptions.forEach((cur) => {
  //         if (cur.id === value) {
  //           res = cur.displayName || "";
  //         }
  //       });
  //       return res;
  //     },
  //   },
  //   {
  //     field: "collectionDate",
  //     headerName: "Collection Date",
  //     width: 150,
  //     flex: 1,
  //     valueGetter: (value, row) => parseTimeToLocal(value),
  //   },
  //   {
  //     field: "actions",
  //     type: "actions",
  //     headerName: "Actions",
  //     width: 150,
  //     cellClassName: "actions",
  //     renderCell: ({ id }) => {
  //       return (
  //         <Button variant="contained" onClick={handleEditClick(id)}>
  //           View Details
  //         </Button>
  //       );
  //     },
  //   },
  // ];

  return (
    <div className="table-collections">
      {/* <DataGrid
        apiRef={gridRef}
        initialState={{ pagination: { paginationModel } }}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[25, 50, 100]}
        rows={collections}
        columns={columns}
        columnGroupingModel={columnGroupingModel}
        sx={{ "--DataGrid-overlayHeight": "1000px" }}
      ></DataGrid> */}

      <EnhancedTable
        loading={loading}
        collections={collections}
        collectionCount={collectionCount}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        handleSelectCollection={handleSelectCollection}
        trapSiteOptions={trapSiteOptions}
        trapTypeOptions={trapTypeOptions}
        setSortModel={setSortModel}

        // initialState={{ pagination: { paginationModel } }}
        // onPaginationModelChange={setPaginationModel}
        // rows={collections}
        // columns={columns}
        // columnGroupingModel={columnGroupingModel}
        // sx={{ "--DataGrid-overlayHeight": "1000px" }}
      ></EnhancedTable>
    </div>
  );
};

export default CollectionsTable;

// <DataGrid
//     // loading={loading}
//     // slotProps={{
//     //   loadingOverlay: {
//     //     variant: "linear-progress",
//     //     noRowsVariant: "linear-progress",
//     //   },
//     // }}
//     // paginationMode="server"
//     apiRef={gridRef}
//     initialState={{ pagination: { paginationModel } }}
//     // rowCount={collectionCount}
//     // paginationModel={paginationModel}
//     onPaginationModelChange={setPaginationModel}
//     rows={collections}
//     columns={columns}
//     // onRowCountChange={collectionCount || 0}
//     columnGroupingModel={columnGroupingModel}
//     sx={{ "--DataGrid-overlayHeight": "1000px" }}
//   ></DataGrid>
